// extracted by mini-css-extract-plugin
export default {"component":"content-loader_component__YFASH"};